import classNames from 'classnames';
import React from 'react';
import Modal, { CloseModalButton, ModalPanel, OpenModalButton } from '../Modal';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const TypeaheadLabelTooltip = ({
  tooltipLinkText,
  tooltipText,
  translations,
  isRightAligned,
}) => {
  const href = useWindowLocationHref();
  return (
    <Modal>
      <div
        data-event-category={href || 'novalue'}
        data-event-action={tooltipLinkText}
        data-event-name={tooltipText}
        className="c-typeahead_tooltip__modal__container"
      >
        <OpenModalButton
          open="c-typeahead__tooltip"
          id="c-typeahead__tooltip"
          className="c-typeahead__tooltip__modal-open"
          ariaLabel={tooltipLinkText}
        >
          <span
            data-event-include
            className="c-typeahead__tooltip__modal-open__icon"
          />
          <p
            data-event-include
            className="c-typeahead__tooltip__modal-open__link"
          >
            {tooltipLinkText}
          </p>
        </OpenModalButton>
        <ModalPanel whenActive="c-typeahead__tooltip">
          <div
            className={classNames('c-typeahead__tooltip__modal-panel', {
              'c-typeahead__tooltip__modal-panel--right-aligned':
                isRightAligned,
            })}
          >
            <CloseModalButton
              id="c-typeahead__tooltip"
              className="c-typeahead__tooltip__modal-close"
            >
              <span className="show-for-sr">
                {translations?.close || 'stäng'}
              </span>
            </CloseModalButton>
            <div className="c-typeahead__tooltip__modal-panel__content">
              <div
                className="c-typeahead__tooltip__modal-panel__description"
                dangerouslySetInnerHTML={{
                  __html: tooltipText,
                }}
              />
            </div>
          </div>
        </ModalPanel>
      </div>
    </Modal>
  );
};

export default TypeaheadLabelTooltip;
